import * as tslib_1 from "tslib";
import getPersonaJsonRequest from 'owa-service/lib/factory/getPersonaJsonRequest';
import getPersonaOperation from 'owa-service/lib/operation/getPersonaOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import targetFolderId from 'owa-service/lib/factory/targetFolderId';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
/**
 * Performs a GetPersona call in the myContacts folder, retrieving the provided personaId
 * It returns "null" if the request fails with ErrorItemNotFound
 */
export default function getContactByPersonaId(personaId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, getPersonaOperation(getPersonaJsonRequest({
                    Header: getJsonRequestHeader(),
                    Body: {
                        PersonaId: {
                            Id: personaId,
                        },
                        ParentFolderId: targetFolderId({
                            BaseFolderId: distinguishedFolderId({
                                Id: 'mycontacts',
                            }),
                        }),
                    },
                })).then(function (response) {
                    // ErrorItemNotFound is "expected": we want to return a "null" Persona and let callers handle it
                    if (response.Body.ResponseClass === 'Success' ||
                        response.Body.ResponseCode === 'ErrorItemNotFound') {
                        return response.Body.Persona;
                    }
                    throw new Error("GetPersona failed (" + response.Body.ResponseCode + " " + response.Body.MessageText + ")");
                })];
        });
    });
}
//# sourceMappingURL=getContactByPersonaId.js.map